export const CommandStatus = {
  Ok: 1,
  PENDING: 2,
};

export const CommandStatusMap = new Map([
  [CommandStatus.Ok, 'OK'],
  [CommandStatus.PENDING, 'PENDING'],
]);